module.exports = __webpack_public_path__ + "static/media/combat(10).5c964f04.PNG";